export const DEFAULT_LANGUAGE = {
    ENGLISH: process.env.REACT_APP_LANGUAGE,
};
